import type { ReactNode } from "react"

/**
 * Shared chrome for a drilled-in lesson-menu view's body: the view's content plus an
 * optional footer row of equal-width action buttons. (The view's title renders in the
 * menu's header bar, which animates separately — see LessonMenu's ViewHeader.)
 */
export function ViewShell({
  children,
  actions,
}: {
  children?: ReactNode
  /** Footer buttons; give each `className="flex-1"` so they share the row equally. */
  actions?: ReactNode
}) {
  return (
    <div className="flex flex-col text-left">
      {/* View Body */}
      {children}

      {/* Footer Actions */}
      {actions ? (
        <div data-test="view actions" className="flex flex-wrap gap-3 px-5 pt-4 pb-5">
          {actions}
        </div>
      ) : null}
    </div>
  )
}
